// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-tile-group[data-v-135ea1df] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.radio-tile-group button[data-v-135ea1df] {\n  width: 49%;\n  margin-top: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
